module.exports = __webpack_public_path__ + "static/media/view5.6383e5cb.jpg";